import { render } from "./OfficeAssignGrid.vue?vue&type=template&id=7fed9bd0&scoped=true"
import script from "./OfficeAssignGrid.vue?vue&type=script&lang=js"
export * from "./OfficeAssignGrid.vue?vue&type=script&lang=js"

import "./OfficeAssignGrid.vue?vue&type=style&index=0&id=7fed9bd0&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fed9bd0"]])

export default __exports__